import React, { useEffect } from 'react';

const Translate = () => {
  useEffect(() => {
    // Redirect to the external URL
    window.location.href = 'https://www.translate.paralegal.lk';
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <p className="text-lg">Redirecting to translate.paralegal.lk...</p>
      </div>
    </div>
  );
};

export default Translate;
